<template>
  <div>
    <div v-if="isDetail">
      <a :href="dowlandLink" target="_blank" v-if="dowlandLink" class="download-template">Descargar documento</a>
    </div>
    <div v-else-if="isVisibleIPT && !isDetail" class="card-file-upload-ipt">
      <div class="card-file-upload-ipt-text">
        <span>{{ nameFileIPT }}</span>
        <p>Archivo cargado</p>
      </div>
      <button @click.prevent="removeFileIPT" :disabled="isBusy">
        <img
          class=""
          :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
        />
      </button>
    </div>
    <div v-else>
      <form
        id="file-upload-form"
        class="uploader"
        @dragover.prevent
        @drop="handleDropIPT"
      >
        <input
          id="work_analysis_file"
          type="file"
          @change="filesSelectedIPT"
          accept=".xlsx, .pdf"
        />
        <label
          for="work_analysis_file"
          id="file-drag"
          class="pointer upload-ipt"
        >
          <div>
            <img src="@/assets/images/icons/upload-cloud-2-line.svg" />
          </div>
          <p>Arrastra aquí el archivo análisis de trabajo.</p>
          <button id="ipt-btn" @click.prevent="openFileExplorerIPT">
            Cargar archivo
          </button>
        </label>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["work_analysis_file", "isBusy", "isDetail", "dowlandLink"],
  data() {
    return {
      nameFileIPT: null,
      fileIPT: null,
      isVisibleIPT: false,
    };
  },
  watch: {
    work_analysis_file() {
      const me = this;
      me.loadFile();
    },
  },
  methods: {
    filesSelectedIPT(event) {
      event.preventDefault();
      const me = this;
      const file = document.querySelector("#work_analysis_file");
      me.fileIPT = file.files[0];
      me.nameFileIPT = file.files[0].name;
      me.validateFile();
    },
    handleDropIPT(event) {
      const me = this;
      event.preventDefault();
      me.fileIPT = event.dataTransfer.files[0];
      me.nameFileIPT = me.file.name;
      me.validateFile();
    },
    openFileExplorerIPT() {
      document.querySelector("#work_analysis_file").click();
    },
    validateFile() {
      const me = this;
      if (
        me.fileIPT.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        me.fileIPT.type !== "application/pdf"
      ) {
        me.nameFileIPT = null;
        me.fileIPT = null;
        me.$bvToast.toast("El archivo debe ser .xlsx, .pdf", {
          title: "Error al subir el archivo",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
          solid: true,
        });
        return false;
      }

      me.isVisibleIPT = me.fileIPT ? true : false;
      me.$emit("uploadFileIPT", me.fileIPT);
    },
    removeFileIPT() {
      const me = this;
      me.nameFileIPT = null;
      me.fileIPT = null;
      me.isVisibleIPT = false;
      me.$emit("uploadFileIPT", me.file);
    },
    loadFile() {
      const me = this;
      if (me.work_analysis_file) {
        me.fileIPT = me.work_analysis_file;
        me.nameFileIPT = me.work_analysis_file.name;
        me.isVisibleIPT = me.work_analysis_file ? true : false;
      }
    },
  },
  mounted() {
    const me = this;
    me.loadFile();
  },
};
</script>

<style lang="scss">
.upload-ipt {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  align-items: center !important;
  padding: 8px !important;
  border-radius: 8px;
  position: relative;
  z-index: 999;
}
.upload-ipt p {
  font-size: 12px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  color: #263238 !important;
}
.upload-ipt img {
  width: 32px !important;
  height: 32px !important;
}
.upload-ipt button {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 32px;
  border-radius: 4px;
  font-size: 16px;
  border: none;
  color: white;
  padding: 6px 0px;
  width: 230px;
  justify-content: center;
}
.card-file-upload-ipt {
  display: flex;
  justify-content: space-between;
  height: 60px;
  width: 350px;
  padding: 12px 8px 12px 8px;
  border-radius: 4px;
  border: 1px solid #eceff1;
  background-color: white;
  margin-bottom: 5px;
}
.card-file-upload-ipt .card-file-upload-ipt-text {
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 12px;
  color: #263238;
}
.card-file-upload-ipt .card-file-upload-ipt-text p {
  font-size: 12px;
  color: #0c9e42;
}
.card-file-upload-ipt button {
  border: none;
  background-color: transparent;
  padding: 0;
}
.download-template {
  font-size: 14px;
  color: #0c9e42;
  text-decoration: underline;
  cursor: pointer;
}
</style>
